import { createStore } from 'vuex';
import VuexPersist from 'vuex-persist';
import { vuexOidcCreateStoreModule } from 'vuex-oidc';
import { setLang as documentUtilsSetLang } from '@utils/documentUtils';

import { appConstants } from '@utils/constants';
import {
    appStateStore,
    customersStore,
    ordersStore,
    ordersStatisticsStore,
    loyaltyTransactionsStore,
    productCategoriesStore,
    reportsStore,
    userStore,
    notificationStore,
    topSellingEventsStore,
    countriesStore,
    statesStore,
    citiesStore,
    currenciesStore,
    attractionsStore,
    hotelPriceRulesStore,
    metadataTableConfigStore,
    bookingStatusesStore,
    offerTokensStore,
    priceRulesetsStore,
} from './modules';
import { LogService } from '@/services';

const vuexLocalStorage = new VuexPersist({
    key: 'gstStore', // The key to store the state on in the storage provider.
    storage: localStorage,
    reducer: (state) => ({
        version: appConstants.VERSION,
        store: {
            appState: appStateStore._persistent.getDataToSave(state),
            oidcStore: state.oidcStore,
            metadataTableConfig: metadataTableConfigStore._persistent.getDataToSave(state),
        },
    }),
    restoreState: (key, storage) => {
        try {
            if (!storage || !storage[key]) {
                return null;
            }
            const state = JSON.parse(storage[key]);
            const store = state.store;

            return {
                appState: appStateStore._persistent.getDataToLoad(store.appState),
                metadataTableConfig: metadataTableConfigStore._persistent.getDataToLoad(
                    store.metadataTableConfig
                ),
            };
        } catch (e) {
            LogService.error(`Vuex state cannot be loaded (${e.message} )`);
            return null;
        }
    },
});

const storeVuex = createStore({
    modules: {
        appState: appStateStore,
        user: userStore,
        customers: customersStore,
        orders: ordersStore,
        ordersStatistics: ordersStatisticsStore,
        productCategories: productCategoriesStore,
        reports: reportsStore,
        loyaltyTransactions: loyaltyTransactionsStore,
        notification: notificationStore,
        topSellingEvents: topSellingEventsStore,
        countries: countriesStore,
        states: statesStore,
        cities: citiesStore,
        currencies: currenciesStore,
        attractions: attractionsStore,
        hotelPriceRules: hotelPriceRulesStore,
        metadataTableConfig: metadataTableConfigStore,
        bookingStatuses: bookingStatusesStore,
        offerTokens: offerTokensStore,
        priceRulesets: priceRulesetsStore,
        oidcStore: vuexOidcCreateStoreModule(
            appConstants.OIDC_SETTINGS,
            // Optional OIDC store settings
            {
                namespaced: true,
                dispatchEventsOnWindow: true,
            },
            // Optional OIDC event listeners
            {
                userLoaded: (user) => LogService.log('OIDC user is loaded:', user),
                userUnloaded: () => {
                    LogService.log('OIDC user is unloaded');
                },
                accessTokenExpiring: () => LogService.log('Access token will expire soon.'),
                accessTokenExpired: () => {
                    LogService.log('Access token did expire');
                    storeVuex.dispatch('oidcStore/authenticateOidc');
                },
                silentRenewError: () => LogService.log('OIDC user is unloaded'),
                userSignedOut: () => LogService.log('OIDC user is signed out'),
            }
        ),
    },
    plugins: [vuexLocalStorage.plugin],
    strict: process.env.NODE_ENV !== 'production',
});

documentUtilsSetLang('en');

export default storeVuex;
